import * as z from 'zod';
import { Data as Data$1, Underwriting as Underwriting$1, Details as Details$1 } from './bid-contract-surety-quote.types.mjs';
import * as bidContractSuretyQuote_types from './bid-contract-surety-quote.types.mjs';
export { bidContractSuretyQuote_types as Bid };
import { Data as Data$2, Underwriting as Underwriting$2, Details as Details$2 } from './bid-to-final-contract-surety-quote.types.mjs';
import * as bidToFinalContractSuretyQuote_types from './bid-to-final-contract-surety-quote.types.mjs';
export { bidToFinalContractSuretyQuote_types as BidToFinal };
import { Data as Data$3, Underwriting as Underwriting$3, Details as Details$3 } from './final-contract-surety-quote.types.mjs';
import * as finalContractSuretyQuote_types from './final-contract-surety-quote.types.mjs';
export { finalContractSuretyQuote_types as Final };

var Data;
(function (Data) {
    Data.schema = z.discriminatedUnion("contractSuretyType", [
        Data$1.schema,
        Data$2.schema,
        Data$3.schema,
    ]);
})(Data || (Data = {}));
var Underwriting;
(function (Underwriting) {
    Underwriting.schema = z.discriminatedUnion("contractSuretyType", [
        Underwriting$1.schema,
        Underwriting$2.schema,
        Underwriting$3.schema,
    ]);
})(Underwriting || (Underwriting = {}));
var Details;
(function (Details) {
    Details.schema = z.discriminatedUnion("contractSuretyType", [
        Details$1.schema,
        Details$2.schema,
        Details$3.schema,
    ]);
})(Details || (Details = {}));

export { Data, Details, Underwriting };
